"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getScaledScoreForRawScore_1 = require("../../evaluate/helpers/getScaledScoreForRawScore");
const parseIntSafe_1 = require("../../helpers/parseIntSafe");
const entity_1 = require("../../type/entity");
function updateRawScoreAndSuccessStatusForScormCard(content, scormDataObject, state) {
    const rawScore = parseIntSafe_1.parseIntSafe(scormDataObject.score_raw);
    state.rawScore = rawScore;
    const maxScore = content.maxScore || 0;
    const minScore = content.minScore || 0;
    state.scaledScore = getScaledScoreForRawScore_1.getScaledScoreForRawScore(rawScore, minScore, maxScore);
    const offerType = content.offerType;
    if (offerType !== entity_1.ContentType.ASSIGNMENT_CARD) {
        return;
    }
    if (state.completionStatus === entity_1.CompletionStatus.COMPLETE) {
        if (scormDataObject.lesson_status === 'passed') {
            state.successStatus = entity_1.SuccessStatus.PASS;
        }
        else if (scormDataObject.lesson_status === 'failed') {
            state.successStatus = entity_1.SuccessStatus.FAIL;
        }
    }
}
exports.updateRawScoreAndSuccessStatusForScormCard = updateRawScoreAndSuccessStatusForScormCard;
//# sourceMappingURL=updateRawScoreAndSuccessStatusForScormCard.js.map